import { useMemo, memo } from "react";
import Chart from "react-apexcharts";
import "./chart.css";

function ChartBarStackedSubCategories({
  data,
  categoryKey,
  categorie,
  valueKey,
  percentageKey,
  chartType = "bar",
  titleX,
  titleY,
  isHorizontal = false,
  seriesName = "Data",
  showPercentage = true,
  max = undefined,
}) {
  const { categories, series } = useMemo(() => {
    if (!data?.length) return { categories: [], series: [] };
    const enriched = data.map((item) => ({
      ...item,
      categoryPop: item[categoryKey] + " - " + item.POP_TIPO,
    }));
    const cats = [...new Set(enriched.map((item) => item.categoryPop))];
    const types = [...new Set(enriched.map((item) => item[categorie]))];
    const srs = types.map((type) => ({
      name: `${type}`,
      data: cats.map((cat) => {
        const item = enriched.find((d) => d.categoryPop === cat && d[categorie] === type);
        return item ? (showPercentage ? item[percentageKey] : item[valueKey]).toFixed(1) : 0 || 1;
      }),
    }));
    return { categories: cats, series: srs };
  }, [data, categoryKey, categorie, showPercentage, percentageKey, valueKey]);

  const options = useMemo(
    () => ({
      chart: { type: chartType, stacked: true },
      responsive: [{
        breakpoint: 480,
        options: { legend: { position: "bottom", offsetX: -10, offsetY: 0 } },
      }],
      plotOptions: { bar: { horizontal: isHorizontal } },
      dataLabels: {
        enabled: true,
        formatter: (val) => showPercentage ? `${val.toFixed(1)}%` : val,
      },
      xaxis: {
        categories,
        title: { text: titleX, style: { color: "var(--text-50)" } },
        labels: { style: { colors: "var(--text-50)" } },
      },
      yaxis: {
        max,
        title: { text: titleY, style: { color: "var(--text-50)" } },
        labels: {
          style: { colors: "var(--text-50)" },
          formatter: (val) => showPercentage ? `${val.toFixed(1)}%` : val,
        },
      },
      tooltip: {
        y: { formatter: (val) => showPercentage ? `${val.toFixed(1)}%` : val },
      },
      legend: { labels: { colors: "var(--text-50)" } },
    }),
    [chartType, isHorizontal, showPercentage, categories, titleX, titleY, max]
  );

  return (
    <Chart options={options} series={series} type={chartType} height="100%" width="100%" />
  );
}

export default memo(ChartBarStackedSubCategories);
